import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleService } from '@next/core-lib/i18n';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { Store, select } from '@ngrx/store';
import { Observable, startWith } from 'rxjs';
import { selectLastSuccessfulManureRequestPost } from 'src/app/store/selectors';

import { SiteState } from '../../shared/models';
import { ManureRequestModel } from '../models/manure-request.model';

@Component({
  selector: 'app-request-confirmation-screen',
  templateUrl: './request-confirmation-screen.component.html',
  styleUrls: ['./request-confirmation-screen.component.scss'],
  standalone: false,
})
export class RequestConfirmationScreenComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly router = inject(Router);
  private readonly localeService = inject(LocaleService);

  lastSuccessfulManureRequestPost$: Observable<ManureRequestModel>;

  pageTitle$ = this.store.pipe(select(SiteSelectors.selectPageTitle));

  constructor() {
    this.lastSuccessfulManureRequestPost$ = this.store
      .select(selectLastSuccessfulManureRequestPost)
      .pipe(startWith(undefined));
  }

  ngOnInit(): void {
    this.store.dispatch(
      SiteActions.updatePageTitle({
        pageTitle: this.localeService.translate('dashboard.page-title'),
      }),
    );
  }

  redirectToNewRequest(): void {
    this.router.navigate(['/request']);
  }

  redirectToRequestOverview(): void {
    this.router.navigate(['']);
  }
}
